import { Chip } from '@mui/material';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { COLUMN_TYPE_ICONS, columnTypeMessages } from '../../../../constants';

interface ColumnTypeChipProps {
  type: string | undefined;
}

export function ColumnTypeChip({ type }: ColumnTypeChipProps) {
  const { $t } = useIntl();

  const { label, icon: Icon } = useMemo(() => {
    const message = type
      ? (columnTypeMessages[type] ?? columnTypeMessages.unknown)
      : columnTypeMessages.unknown;
    return {
      label: $t(message),
      icon: type ? COLUMN_TYPE_ICONS[type] : null,
    };
  }, [type, $t]);

  if (!type) {
    return null;
  }

  return (
    <Chip
      sx={{
        color: 'text.secondary',
        fontSize: '0.7rem',
        '& .MuiChip-label': {
          color: 'text.secondary',
          fontSize: '0.7rem',
        },
      }}
      icon={Icon ? <Icon fontSize="inherit" sx={{ pl: 0.5 }} /> : undefined}
      label={label}
      size="small"
      variant="outlined"
    />
  );
}
